import Actions from '../../odata/actions';

const actions = new Actions('feedbackItem', 'feedbackItems');

export default actions;
